module.exports = __webpack_public_path__ + "img/footer_onpremise.51645f89.png";